import { TVehicle } from "types";

interface ILocationReducer {
  vehicles: TVehicle[];
  filter: any;
}

const LocationReducer = ({ vehicles, filter }: ILocationReducer) => {
  if (!(filter.location && filter.location.length)) return vehicles;
  return vehicles.filter(
    ({ location, locations }) =>
      (location && filter.location.includes(location.id)) ||
      (locations && locations.find((e) => filter.location.includes(e.id)))
  );
};

export default LocationReducer;
